<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>我的服务者</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item label="城市">
                    <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" style="width:120px" filterable>
                        <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="驿站">
                    <el-select v-model="listQuery.postStationId" clearable placeholder="请选择驿站"  style="width:150px" filterable>
                        <template v-for="(item,index) in postStationList">
                            <el-option :key="index" v-if="item.cityId==listQuery.cityId" :label="item.postStationName" :value="item.id+''"> </el-option>
                        </template>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="服务站">
                    <el-select v-model="listQuery.stationId" clearable placeholder="请选择服务站" style="width:150px" filterable>
                        <template v-for="(item,index) in allStationList">
                            <el-option :key="index" v-if="item.cityId==listQuery.cityId" :label="item.stationName" :value="item.id+''"> </el-option>
                        </template>
                    </el-select>
                </el-form-item>

                <!-- <el-form-item label="服务者类型">
          <el-select v-model="listQuery.workerType" clearable placeholder="请选择服务类型" filterable>
            <el-option v-for="(item,index) in workTypes" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
                <el-form-item label="服务者姓名">
                    <el-input v-model="listQuery.workerName" maxlength="11" style="width:150px" placeholder="请输入服务者姓名" clearable></el-input>
                </el-form-item>

                <el-form-item label="服务者电话">
                    <el-input v-model="listQuery.workerTel" maxlength="11" style="width:150px" placeholder="请输入服务者电话" clearable></el-input>
                </el-form-item>

                <!-- <el-form-item label="服务者归属">
          <el-select v-model="listQuery.workerBelongId" clearable placeholder="请选择服务者归属" filterable>
            <el-option v-for="(item,index) in supplierList" :key="index" :label="item.franchiseeName" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->

                <el-form-item label="服务者状态">
                    <el-select v-model="listQuery.state" clearable placeholder="服务者状态" style="width:150px" filterable>
                        <el-option v-for="(item,index) in workerState" :key="index" :label="item" :value="index"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="服务渠道" label-width="90px">
                    <el-select v-model="listQuery.serviceChannel"  style="width:150px" clearable placeholder="服务渠道" filterable>
                        <el-option v-for="(item,index) in serviceChannels" :key="index" :label="item" :value="index"></el-option>
                    </el-select>
                </el-form-item>

                <!-- <el-form-item label="服务者标签">
                    <el-select v-model="listQuery.label" clearable  style="width:150px" placeholder="请选择" filterable>
                        <el-option v-for="(item,index) in labelList" :key="index" :label="item.labelName" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item> -->

                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                     <el-button v-per="'addMeiTuanServant'"  icon="el-icon-edit"  type="primary" plan @click="handleCreateMT">添加盒马人员</el-button>
                </el-form-item>

            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column prop="id" label="服务者Id" width="100"></el-table-column>
                <el-table-column prop="workerNo" label="服务者基本信息" width="160">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <span style="font-weight: 600;">服务者编号:</span> {{ scope.row.workerNo }}<br />
                            <span style="font-weight: 600;">服务者名称:</span> {{ scope.row.workerName }}<br />
                            <span style="font-weight: 600;">加盟商:</span> {{ scope.row.workerBelongName }}<br />
                            <span style="font-weight: 600;">服务渠道:</span> <el-tag
                                :type="scope.row.serviceChannel in serviceChannels ? '' : 'warning'"> {{
                scope.row.serviceChannel in serviceChannels ? serviceChannels[scope.row.serviceChannel]
                    : '未设置'
            }}</el-tag><br />
                            <span style="font-weight: 600;">信息是否完善:</span> <el-tag
                                :type="scope.row.ocrState == 1 ? 'success' : 'info'">{{ scope.row.ocrState == 1 ? '已完善'
                : '未完善' }}</el-tag><br />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="workerNo" label="服务者其他信息" width="230">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <span style="font-weight: 600;">服务者性别:</span> {{ scope.row.gender }}<br />
                            <span style="font-weight: 600;">服务者籍贯:</span> {{ scope.row.nativePlace }}<br />
                            <span style="font-weight: 600;">服务者身份证:</span> {{ scope.row.workerIdcard }}<br />
                            <span style="font-weight: 600;">服务者电话:</span>
                            <phoneTag :phone="scope.row.workerTel" /><br />

                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="workerName" label="服务者城市信息" width="200">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <span style="font-weight: 600;">城市:</span> {{ scope.row.cityName }}<br />
                            <!-- <span style="font-weight: 600;">驿站:</span> {{ scope.row.cityDto.postStationName }}<br />
                            <span style="font-weight: 600;">驿站老师:</span> {{ scope.row.workerPostLeader }}<br /> -->
                            <span style="font-weight: 600;">服务站:</span> {{ scope.row.cityDto.stationName }}<br />
                            <span style="font-weight: 600;">商家运营:</span> {{ scope.row.workerManager }}<br />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="workerName" label="服务者证件状态" width="200">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <span style="font-weight: 600;">新农保上传状态:</span> {{ scope.row.newFarmerStatus }}<br />
                            <span style="font-weight: 600;">签约结果:</span> <el-tag
                                :type="scope.row.signContractState == 1 ? 'success' : 'warning'">{{
                scope.row.signContractState == 1 ? '已签约' : '未签约' }}</el-tag><br />
                            <span style="font-weight: 600;">健康证上传结果:</span> <el-tag
                                :type="scope.row.healthCertificate == 1 ? 'success' : 'warning'">{{
                healthCertificateState[scope.row.healthCertificate] }}</el-tag><br />
                            <span style="font-weight: 600;">是否复职:</span> {{ scope.row.reinstated == '1' ? '是' : '否'
                            }}<br />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="workerName" label="服务者状态信息" width="200">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <span style="font-weight: 600;">服务者状态:</span> <el-tag
                                :type="scope.row.state == 2 ? 'success' : 'warning'">{{ workerState[scope.row.state]
                                }}<br />{{ workerSubState[scope.row.subState] }}</el-tag><br />
                            <span style="font-weight: 600;">上线审批状态:</span> {{ approveState[scope.row.approveState]
                            }}<br />
                            <span style="font-weight: 600;">上线时间:</span> {{ scope.row.onlineTime  | dateFormatA}}<br />
                            <span style="font-weight: 600;">解约时间:</span> {{ scope.row.leaveTime  | dateFormatA}}<br />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="workerName" label="招招盈" width="150">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <span style="font-weight: 600;">招招盈资格:</span> {{ scope.row.meetZzy == '1' ? '是' : '否'
                            }}<br />
                            <span style="font-weight: 600;">是否暂停招招盈:</span> {{ scope.row.pauseZzy == '1' ? '是' :
                (scope.row.pauseZzy == '0' ? '否' : '') }}<br />
                        </div>
                    </template>
                </el-table-column>

                <el-table-column prop="workerName" label="其他">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <span style="font-weight: 600;">业务线:</span> <el-tag>{{ scope.row.buzLine | filterWorkerType
                                }}</el-tag><br />
                            <span style="font-weight: 600;">服务者归属:</span> {{ scope.row.workerBelongName }}<br />
                            <span style="font-weight: 600;">服务者休息日:</span> {{ scope.row.restDay }}<br />
                            <span style="font-weight: 600;">创建时间:</span> {{ scope.row.createTime | dateFormatA }}<br />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-view" @click="handleDetail(scope.row)">详情</el-button>
                        <!-- <el-button type="text" v-if="scope.row.workerBelongId==globalData.userInfo.id&&scope.row.state!=2" icon="el-icon-info" @click="handleJoin(scope.row)">上线</el-button> -->
                        <el-button type="text" v-per="'myruzhi'" v-if="scope.row.state==1&&scope.row.approveState==0" icon="el-icon-info" @click="handleJoin(scope.row)">上线</el-button>
                        <el-button type="text" v-per="'myruzhi'" v-if="scope.row.state==1&&scope.row.approveState==3" icon="el-icon-info" @click="handleJoin(scope.row)">再次申请上线</el-button>

                        <!-- <el-button type="text" v-if="scope.row.approveState==1" icon="el-icon-info" @click="toSp(scope.row)">审批</el-button> -->
                        <el-button type="text" v-per="'myliushi'" v-if="scope.row.state==1" icon="el-icon-info" @click="handleLoss(scope.row,2,5)">流失</el-button>
                         <el-button type="text" v-if="checkSignState(scope.row)" @click="clickSign(scope.row)">签署合作协议</el-button>
                        <!-- <el-button type="text" v-if="scope.row.state==2" icon="el-icon-info" @click="handleLoss(scope.row,1,null)">解约</el-button>
                        <el-button type="text" v-if="scope.row.state==3" icon="el-icon-info" @click="reinstated(scope.row)">复职</el-button> -->
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <!-- <el-dialog title="服务者背调" :visible.sync="showBIVisible" width="900px" :close-on-click-modal="false" center> -->
        <addServantDia ref="addServantDiaRef" />

        <!--线索流失 -->
        <leaveLossForm ref="leaveLossFormRef" />

         <!--保洁服务合作协议-->
        <signBaodi ref="signBaodi" />

           <!--美团人员录入，简化录入-->
                <addMeiTuanServant ref="addMeiTuanServant" />

    </div>
</template>
<script>
import Pagination from "@/components/common/Pagination";
import commutilData from "@/components/common/commutil.data";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import workercrmapi from "@/script/api/workercrmapi";
import addServantDia from "@/components/workercrm/addServantDia.vue";
import globalData from "@/components/common/globaldata/global.data.vue";
import leaveLossForm from "@/components/workercrm/compent/leaveLossForm.vue";
import phoneTag from "@/components/workercrm/compent/phoneTag.vue";
import signBaodi from "@/components/workercrm/contract/compent/signBaodi";
import addMeiTuanServant from "@/components/workercrm/compent/addMeiTuanServant";
import moment from "moment";

let vm;
export default {
    components: { Pagination, addServantDia, leaveLossForm, phoneTag,signBaodi,addMeiTuanServant },
    filters: {
        filterWorkerType(type) {
            if (type == 1) return "保洁";
            if (type == 2) return "保姆";
            if (type == 3) return "品类";
        },
        dateFormatA(date) {
            if (date == undefined || date == "") {
                return "";
            }
            return moment(date).format("YYYY-MM-DD HH:mm");
        }
    },
    data() {
        return {
            healthCertificateState: {
                0: "未上传",
                1: "已上传",
                2: "健康证即将到期",
                3: "健康证已到期",
            },
            workerState: {
                1: "待上线",
                2: "已上线",
                3: "已解约",
                // 4: "复职",
                5: "流失",
            },
            serviceChannels:{
                1:"盒马",
                2:"私域",
                3:"共用"
            },
            approveState: {
                1: "待审批",
                2: "审批通过",
                3: "未通过",
            },
            workerSubState: {
                1: '背调失败', 2: '培训淘汰', 3: '拒绝上线', 4: '上线审批拒绝'
            },
            workTypes: commutilData.serviceModelList,
            supplierList: [],
            listData: [],
            cityList: [],
            sysUserList: [],
            postStationList: [],
            allStationList: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                selectType: 2,
                cityId: null,
                postStationId: null,
                stationId: null,
                workerName: "",
                workerBelongId: null,
                label: null,
                userId: globalData.userInfo.id,
            },
            showBIVisible: false,
            labelList: [],
        };
    },

    created() {
        this.getAllCity();
        // this.getAllPostStation();
        this.getAllStationList();

        this.getSupplierList();
        this.querySearch();
        this.getAllSkill();
    },
    methods: {
         handleCreateMT() {
            let date = moment(new Date()).format("YYYY-MM-DD HH:ss:mm");
            this.$refs.addMeiTuanServant.addServantData(
                '',
                '',
                '',
                // step,
                date,
            );
        },
        checkSignState(row){
            //签署合同按钮判断
            if(row.state==1&&row.backInvestigate==true&&row.signContractState==0){
                return true;
            }
            return false;
        },
        clickSign(row) {
            //签约 未来区分保姆或保洁合同
            this.$refs.signBaodi.showDetail(row.workerNo);
        },
        getAllSkill() {
            workercrmapi.$axiosEmLableSkillGetAllLabelSkill().then((res) => {
                if (res.data.errno == 0) {
                    this.labelList = res.data.data;
                }
            });
        },
        handleLoss(row, type, subType) {
            //流失或解约
            //subType解约时，子类型1线索流失，2上线失败，3跟单失败，4培训失败
            this.$refs.leaveLossFormRef.leaveLossClick(row, type, subType);
        },
        handleJoin(row) {
            //this.showBIVisible = true;
            console.info(row);
            let date = moment(new Date()).format("YYYY-MM-DD HH:ss:mm");
            //表示上线已完成到第几步：1信息完善 2背调 3签约 4正式上线
            var step = 1; //已上线
            if (row.state == 2) step = 4;
            else if (row.signContractState) step = 4;
            else if (row.backInvestigate) step = 3;
            else if (row.ocrState == 1) step = 2;
            console.info("step" + step);
            this.$refs.addServantDiaRef.addServantData(
                row.id,
                row.cityId,
                row.buzLine,
                step,
                date,
                row
            );
        },
        handleDetail(row) {
            this.$router.push({
                path: "/workermanager/lifeManager/servantDetail",
                query: {
                    id: row.id,
                },
            });
        },
        //查询
        querySearch() {
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            console.log(globalData.franchisee);
            this.listQuery.workerBelongId = globalData.franchisee.id;
            workercrmapi.$axiosGetWorkerList(this.listQuery).then((res) => {
                if (res.data.errno == 0) {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                }
            });
        },
        getSupplierList() {
            //获取归属
            workercrmapi
                .$axiosGetSupplierList({ companyId: globalData.company.id })
                .then((res) => {
                    this.supplierList = res.data.data;
                });
        },
        getAllCity() {
            //城市下拉框
            wmsApi.$axiosgetallCity({userId: globalData.userInfo.id}).then((res) => {
                if (res.data.errno == 0) {
                    this.cityList = res.data.data;
                }
            });
        },
        getAllPostStation() {
            //驿站
            workercrmapi.$axiosPostStationgetAllList({ userId: globalData.userInfo.id }).then((res) => {
                if (res.data.errno == 0) {
                    this.postStationList = res.data.data;
                }
            });
        },
        getAllStationList() {
            //服务站
            wmsApi.$axiosGetAllStationList({ userId: globalData.userInfo.id }).then((res) => {
                if (res.data.errno == 0) {
                    this.allStationList = res.data.data;
                }
            });
        },
        getSysUser() {
            //城市下拉框
            service.$axiosSysUsergetallUser().then((res) => {
                if (res.data.errno == 0) {
                    this.sysUserList = res.data.data;
                }
            });
        },
    },
    beforeCreate() {
        vm = this;
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>
